import React from 'react';
import { Button, EmptyState } from '../design-system/ui';
import { Msg, useFormatMessage } from '../i18n-review/client/Msg';

/**
 * Shown when the main layout tree (or a page section) hits an error boundary: the design system's
 * error EmptyState with a reload action and a way home. Keeps chrome/providers mounted when possible.
 */
export function LayoutPageErrorFallback() {
  const formatMessage = useFormatMessage();
  return (
    <div className="flex min-h-[40vh] items-center justify-center px-4 py-12">
      <EmptyState
        kind="error"
        headingLevel={1}
        title={formatMessage({
          id: 'layoutErrorFallback.title',
          defaultMessage: 'Something went wrong',
          description: 'Title when a page section fails to render',
        })}
        action={
          <div className="flex flex-col justify-center gap-3 sm:flex-row">
            <Button
              variant="primary"
              onClick={() => {
                if (typeof window !== 'undefined') window.location.reload();
              }}
            >
              <Msg
                id="layoutErrorFallback.reload"
                defaultMessage="Reload page"
                description="Button to reload after an error"
              />
            </Button>
            <Button variant="secondary" href="/">
              <Msg id="layoutErrorFallback.home" defaultMessage="Go to home" description="Link to home after an error" />
            </Button>
          </div>
        }
      >
        <Msg
          id="layoutErrorFallback.body"
          defaultMessage="Please try reloading the page. If the problem continues, we have been notified."
          description="Body when a page section fails to render"
        />
      </EmptyState>
    </div>
  );
}
